(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["footer-accessibility-link"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-userway-trigger]');
    if (!trigger) return;

    event.preventDefault();

    if (window.UserWay?.widgetOpen) {
      window.UserWay.widgetOpen();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sidebar-page-scripts"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-sidebar-page]').forEach((sidebarRoot) => {
    const sidebarToggle = sidebarRoot.querySelector('.sidebar-menu-toggle');

    if (sidebarToggle) {
      sidebarToggle.addEventListener('click', () => {
        const isOpen = sidebarToggle.getAttribute('aria-expanded') === 'true';
        sidebarToggle.setAttribute('aria-expanded', String(!isOpen));
        sidebarRoot.querySelectorAll('.page-sidebar__links, .page-sidebar__menu').forEach((element) => {
          element.classList.toggle('open');
        });
      });
    }

    sidebarRoot.querySelectorAll('.accordion').forEach((accordion) => {
      accordion.addEventListener('click', () => {
        accordion.classList.toggle('open');
      });
    });

    function scrollToHash(hash) {
      const target = sidebarRoot.querySelector(hash);
      if (!target) return;

      const top = target.getBoundingClientRect().top + window.pageYOffset - 115;
      window.scrollTo({ top, behavior: 'smooth' });
    }

    sidebarRoot.querySelectorAll('a[href*="#"]:not([href="#"])').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (!link.hash) return;

        event.preventDefault();
        scrollToHash(link.hash);
      });
    });

    const initialHash = window.location.hash;
    if (initialHash.length > 0) {
      window.scrollTo(0, 0);
      window.setTimeout(() => {
        scrollToHash(initialHash);
      }, 500);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
